import React, { useState, useEffect, useRef } from 'react';
import { Navbar, Container, Nav, Dropdown, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import { FiUser } from "react-icons/fi";
import { useAuth } from '../context/AuthContext';
import { IoNotificationsOutline } from "react-icons/io5";
import { IoLogOutOutline } from "react-icons/io5";

const Header = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('Language');
  const [scrolled, setScrolled] = useState(false);
  const [navHeight, setNavHeight] = useState(0);
  const navRef = useRef(null);
  const { authenticated } = useAuth();

  const handleSelect = (langLabel) => {
    setSelectedLanguage(langLabel);
  };

  // Dynamically track navbar height
  useEffect(() => {
    const updateNavHeight = () => {
      if (navRef.current) {
        const height = navRef.current.getBoundingClientRect().height;
        setNavHeight(height);
      }
    };

    updateNavHeight();
    window.addEventListener('resize', updateNavHeight);
    return () => window.removeEventListener('resize', updateNavHeight);
  }, []);

  // Set stick-header on scroll past navHeight
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > navHeight);
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [navHeight]);

  return (
    <Navbar
      ref={navRef}
      bg="light"
      className={`main-header ${scrolled ? 'stick-header' : ''} ${authenticated ? 'authenticated' : ''}`}
      fixed="top"
    >
      <Container className="d-flex justify-content-between align-items-center">
        {/* Logo */}
        <Navbar.Brand as={Link} to="/">
          <Image src={logo} alt="Logo" height={40} />
        </Navbar.Brand>

        {/* Static Language Dropdown & Login */}
        <Nav className="align-items-center gap-3 flex-row">
          {authenticated && (
            <Dropdown align="end" className="notification-dropdown">
              <Dropdown.Toggle
                variant="link"
                className="nav-link notification-dropdown"
                id="notification-dropdown"
              >
                <IoNotificationsOutline />
              </Dropdown.Toggle>

              <Dropdown.Menu className="notifications-menu p-3 shadow">
                <h6 className="fw-bold mb-3">Notifications</h6>

                <div className="notification-item mb-3 d-flex gap-2 align-items-start">
                  <div>
                    <div className="fw-semibold">New Message</div>
                    <div className="text-muted small">You have a new message from John.</div>
                    <div className="text-muted small">5 mins ago</div>
                  </div>
                </div>

                <div className="notification-item mb-3 d-flex gap-2 align-items-start">
                  <div>
                    <div className="fw-semibold">Task Reminder</div>
                    <div className="text-muted small">Meeting starts in 30 mins.</div>
                    <div className="text-muted small">10 mins ago</div>
                  </div>
                </div>

                <div className="text-center mt-2">
                  <Link to="/notifications" className="text-success fw-semibold">
                    View All
                  </Link>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          )}

          <Dropdown align="end">
            <Dropdown.Toggle
              variant="outline-secondary"
              id="language-dropdown"
              className="language-button"
            >
              {selectedLanguage}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleSelect('English')}>English</Dropdown.Item>
              <Dropdown.Item onClick={() => handleSelect('Français')}>Français</Dropdown.Item>
              <Dropdown.Item onClick={() => handleSelect('Español')}>Español</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {!authenticated && (
            <Nav.Link
              as={Link}
              to="/signin"
              className="btn btn-primary nav-link-btn d-flex align-items-center gap-1"
            >
              <FiUser /> <span>Sign In</span>
            </Nav.Link>
          )}
          {authenticated && (
            <Dropdown align="end" className="user-dropdown">
              <Dropdown.Toggle
                variant="link"
                id="user-dropdown"
                className="d-flex align-items-center gap-2 user-toggle"
              >
                <img
                  src="https://i.pravatar.cc/40?u=client" 
                  alt="Profile"
                  className="user-avatar"
                />
                <span className="fw-semibold user-name">John Doe</span> {/* replace with dynamic name */}
              </Dropdown.Toggle>

              <Dropdown.Menu className="user-menu shadow">
                <Dropdown.Item as={Link} to="/profile"><FiUser /> My Profile</Dropdown.Item>
                <Dropdown.Item onClick={() => {
                  localStorage.removeItem('authenticated');
                  window.location.href = '/signin';
                }}>
                  <IoLogOutOutline /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </Nav>
      </Container>
    </Navbar>
  );
};

export default Header;
